import { Component, OnInit } from '@angular/core';
import { E5coreUiSearchMenuBase } from './e5core-ui-search-menu-base';

@Component({
  selector: 'e5core-ui-search-menu-bootstrap',
  templateUrl: './e5core-ui-search-menu-bootstrap.component.html',
  styleUrls: ['./e5core-ui-search-menu-bootstrap.component.css']
})
export class E5coreUiSearchMenuBootstrapComponent extends E5coreUiSearchMenuBase {

  constructor() {
    super();
  }

  ngOnInit() {
  }

}
